let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fgjrS")]).then(() => parcelRequire('3mMPp'));